export class ListIngestionPipelineTagsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "Array<IngestionPipelineTag>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListIngestionPipelineTagsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
